import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { registerAuthSessionProvider } from '@/features/auth/auth.store';

import { App } from './App';
import './index.css';

// El `SessionProvider` debe existir **antes** del primer render: si no, las
// consultas del arranque (con la sesión ya guardada) salen sin el token y un 401
// cierra la sesión. Registrarlo dentro de un `useEffect` llegaba tarde.
registerAuthSessionProvider();

const container = document.getElementById('root');

if (!container) {
  throw new Error('No se encontró el elemento #root en index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
